import config from "config"
import { FaQuoteRight } from "react-icons/fa"
import httpService from "services/httpService"

const endpoint = `${config.api}/Projects`

export function getProjectList() {
  return {
    items: [
      {
        slug: "al-khan-sharif",
        title: "Al Khan Sharjah",
        listImageOuter: "/assets/projects/al-khan-sharif/image1.jpg",
        listImageInner: "/assets/projects/al-khan-sharif/image2.jpg",
        hero: "/assets/projects/al-khan-sharif/image2.jpg",
        description:
          "The Palace Hotel Al Khan, Sharjah's premier waterfront resort, blends modern luxury with Emirati heritage through its low-rise, village-inspired architecture, serene beachfront villas, and tranquil landscaped courtyards. Perkins&Will’s sensitive integration of contemporary forms, traditional textures, and privacy-focused design creates a uniquely authentic experience, redefining luxury hospitality along Sharjah's historic coastline.",
        table: {
          headers: [
            "Location",
            "Category",
            "Materials",
            "Area",
            "Architect",
            "Year",
          ],
          details: [
            "Al Khan, Sharjah, UAE",
            "Luxury Waterfront Resort",
            "Coral stone, sand-toned plaster, timber, glass, steel",
            "66,300 sqm",
            "	Perkins&Will (Dubai) & NAGA Architects",
            "2025",
          ],
        },
        quoteRight:
          '"Where whispers of history meet the rhythm of the sea, The Palace Hotel Al Khan is a timeless embrace between heritage and horizon."',
        quoteCenter:
          "Rooted in heritage, crafted for tomorrow.",
        gallery: [
          "/assets/projects/al-khan-sharif/image1.jpg",
          "/assets/projects/al-khan-sharif/image2.jpg",
          "/assets/projects/al-khan-sharif/image3.jpg",
          "/assets/projects/al-khan-sharif/image4.jpg",
          "/assets/projects/al-khan-sharif/image5.jpg",
          "/assets/projects/al-khan-sharif/image6.jpg",
          "/assets/projects/al-khan-sharif/image7.jpg",
          "/assets/projects/al-khan-sharif/image8.jpg",
        ],
        detailOne: {
          title: "Sustainability Meets Serenity",
          text: "The resort's design leverages passive cooling, lush landscaping, and careful spatial planning. Palm-lined walkways, open-air spaces, and shaded areas foster environmental sustainability and offer tranquility, ensuring guest comfort year-round.",
          image: "/assets/projects/al-khan-sharif/detail1.jpg",
        },

        detailTwo: {
          title: "Harmony with Heritage",
          text: "Design gracefully integrates Sharjah's coastal heritage, blending restored historic structures with low-rise contemporary pavilions. Courtyards, pathways, and intimate gardens create an authentic Emirati village experience.",
          image: "/assets/projects/al-khan-sharif/detail2.jpg",
        },
      },

      {
        slug: "blvd-heights",
        title: "BLVD Heights",
        listImageOuter:
          "/assets/projects/blvd-heights/image2.jpg",
        listImageInner:
          "/assets/projects/blvd-heights/image1.jpg",
        hero: "/assets/projects/blvd-heights/image1.jpg",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        table: {
          headers: [
            "Location",
            "Category",
            "Materials",
            "Area",
            "Architect",
            "Year",
          ],
          details: [
            "Lounge",
            "Interior",
            "Marble, Wood",
            "250 sqm",
            "i/o Atelier",
            "2023",
          ],
        },
        quoteRight:
          "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque",
        quoteCenter:
          "Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam",
          gallery: [
            "/assets/projects/blvd-heights/image1.jpg",
            "/assets/projects/blvd-heights/image2.jpg",
            "/assets/projects/blvd-heights/image3.jpg",
            "/assets/projects/blvd-heights/image4.jpg",
            "/assets/projects/blvd-heights/image5.jpg",
            "/assets/projects/blvd-heights/image6.jpg",
            "/assets/projects/blvd-heights/image7.jpg",
            "/assets/projects/blvd-heights/image8.jpg",
        ],
        detailOne: {
          title: "Ut enim ad minima veniam",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          image: "/assets/projects/blvd-heights/detail1.jpg",
        },

        detailTwo: {
          title: "Quis autem vel eum",
          text: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit",
          image: "/assets/projects/blvd-heights/detail2.jpg",
        },

        inspirationSection: {
          title: "Nam libero tempore",
          description:
            "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio.",
        },

        inspirationBoard: [
          "/assets/projects/blvd-heights/board.jpg",
        ],
      },

      {
        slug: "bnp-paribas",
        title: "BNP Paribas",
        listImageOuter: "/assets/projects/bnp-paribas/image1.jpg",
        listImageInner: "/assets/projects/bnp-paribas/image2.jpg",
        hero: "/assets/projects/bnp-paribas/image2.jpg",

        description:
          "The BNP Paribas Dubai workspace design blends Dubai's cultural heritage with French sophistication, creating a dynamic, collaborative environment. The concept incorporates flexible hubs, sustainable materials, and timeless design elements to foster innovation, teamwork, and pride, while reflecting the bank’s regional and historical identity.",
        table: {
          headers: [
            "Location",
            "Category",
            "Materials",
            "Area",
            "Architect",
            "Year",
          ],
          details: [
            "?",
            "Interior",
            "???",
            "??? sqm",
            "I/O Atelier",
            "2022",
          ],
        },
        quoteRight:
          '"Where the Soul of Paris Meets the Spirit of Dubai in Every Detail."',
        quoteCenter:
          'Designing spaces that are not only beautiful but deeply aligned with the unique needs and vision of our clients.',
          gallery: [
            "/assets/projects/bnp-paribas/image1.jpg",
            "/assets/projects/bnp-paribas/image2.jpg",
            "/assets/projects/bnp-paribas/image3.jpg",
            "/assets/projects/bnp-paribas/image4.jpg",
        ],
        detailOne: {
          title: "Bespoke Design",
          text: "At I/O Atelier, we prioritize our clients' unique needs, creating tailored spaces that reflect their vision and values. Our bespoke designed elements play a key role, with each piece carefully crafted to enhance both aesthetics and functionality, ensuring a seamless blend of style, comfort, and practicality.",
          image: "/assets/projects/bnp-paribas/hero.jpg",
        },

        inspirationSection: {
          title: "Where French Elegance Meets Dubai's Spirit",
          description:
            "Inspired by the cultural vibrancy of Dubai and the timeless elegance of French heritage, the design seamlessly blends traditional elements with modern sophistication. Drawing from the warmth of French cafés and the dynamic spirit of Dubai, every detail— from the choice of materials to the layout—reflects a harmonious fusion of local identity and global influence, creating a space that encourages collaboration, creativity, and connection.",
        },

        inspirationBoard: [
          "/assets/projects/bnp-paribas/board.jpg",
        ],
      },

      {
        slug: "british-airways-miami",
        title: "British Airways Miami",
        listImageOuter:
          "/assets/projects/british-airways-miami/image1.jpg",
        listImageInner:
          "/assets/projects/british-airways-miami/image2.jpg",
        description:
          "A transformative lounge experience blending British elegance with Miami’s heritage. Featuring Contour, a fluid guiding installation, the design offers immersive zones, smart adaptability, and sustainable materials, redefining luxury travel as a Home Before Home.",
        hero: "/assets/projects/british-airways-miami/iamge2.jpg.jpg",

        table: {
          headers: [
            "Location",
            "Category",
            "Materials",
            "Area",
            "Architect",
            "Year",
          ],
          details: [
            "Lounge",
            "Interior",
            "timber, terrazzo, bio-based finishes",
            "1000 sqm",
            "I/O Atelier",
            "2023",
          ],
        },
        quoteRight:
          '"British elegance meets Miami’s spirit in a seamless, sustainable, and immersive Home Before Home experience."',
        quoteCenter:
          '"A dialogue between softness and structure, where diffused light and refined textures shape an inviting, layered atmosphere."',
          gallery: [
            "/assets/projects/british-airways-miami/image1.jpg",
            "/assets/projects/british-airways-miami/image2.jpg",
            "/assets/projects/british-airways-miami/image3.jpg",
        ],
        detailOne: {
          title: "Contour Based Design",
          text: "A modern zoning strategy using natural landforms to create seamless transitions between spaces.",
          image: "/assets/projects/british-airways-miami/detail1.png",
        },

        detailTwo: {
          title: "Zoning Layout",
          text: "A structured approach to spatial organization, ensuring functional and aesthetic balance.",
          image: "/assets/projects/british-airways-miami/detail2.png",
        },

        inspirationSection: {
          title: "Flowing Forms and Natural Rhythms",
          description:
            "Inspired by Miami’s natural landscapes and urban rhythm, the lounge design blends fluid coastal forms with structured city movement. Sinuous lines and organic contours guide spatial flow, while natural woods, textured stone, terrazzo, and soft fabrics evoke warmth and a strong sense of place. Layered lighting and subtle zone transitions mirror the city’s shifting atmospheres, creating an intuitive, immersive experience that balances relaxation, social connection, and productivity in a timeless, contextually rich setting."
        },

        inspirationBoard: [
          "/assets/projects/british-airways-miami/board.png",
        ],
      },

      {
        slug: "chedi-hotel-oman",
        title: "Chedi Hotel Oman",
        listImageOuter: "/assets/projects/chedi-hotel-oman/image1.jpg",
        listImageInner: "/assets/projects/chedi-hotel-oman/image2.jpg",
        hero: "/assets/projects/chedi-hotel-oman/image2.jpg",

        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        table: {
          headers: [
            "Location",
            "Category",
            "Materials",
            "Area",
            "Architect",
            "Year",
          ],
          details: [
            "Lounge",
            "Interior",
            "Marble, Wood",
            "250 sqm",
            "i/o Atelier",
            "2023",
          ],
        },
        quoteRight:
          "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque",
        quoteCenter:
          "Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam",
          gallery: [
            "/assets/projects/chedi-hotel-oman/image1.jpg",
            "/assets/projects/chedi-hotel-oman/image2.jpg",
            "/assets/projects/chedi-hotel-oman/image3.jpg",
            "/assets/projects/chedi-hotel-oman/image4.jpg",
            "/assets/projects/chedi-hotel-oman/image5.jpg",
            "/assets/projects/chedi-hotel-oman/image6.jpg",
            "/assets/projects/chedi-hotel-oman/image7.jpg",
            "/assets/projects/chedi-hotel-oman/image8.jpg",
            "/assets/projects/chedi-hotel-oman/image9.jpg",
            "/assets/projects/chedi-hotel-oman/image10.jpg",
            "/assets/projects/chedi-hotel-oman/image11.jpg",
            "/assets/projects/chedi-hotel-oman/image12.jpg",
            "/assets/projects/chedi-hotel-oman/image13.jpg",
        ],
        detailOne: {
          title: "Ut enim ad minima veniam",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          image: "/assets/projects/chedi-hotel-oman/detail1.jpg",
        },

        detailTwo: {
          title: "Quis autem vel eum",
          text: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit",
          image: "/assets/projects/chedi-hotel-oman/detail2.jpg",
        },

        inspirationSection: {
          title: "Nam libero tempore",
          description:
            "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio.",
        },

        inspirationBoard: [
          "/assets/projects/al-khan-sharif/board.jpg",
        ],
      },
      {
        slug: "difc-members-club",
        title: "DIFC Members Club",
        listImageOuter:
          "/assets/projects/difc-members-club/image1.jpg",
        listImageInner:
          "/assets/projects/difc-members-club/image2.jpg",
        hero: "/assets/projects/difc-members-club/image2",

        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        table: {
          headers: [
            "Location",
            "Category",
            "Materials",
            "Area",
            "Architect",
            "Year",
          ],
          details: [
            "Lounge",
            "Interior",
            "Marble, Wood",
            "250 sqm",
            "i/o Atelier",
            "2023",
          ],
        },
        quoteRight:
          "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque",
        quoteCenter:
          "Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam",
          gallery: [
            "/assets/projects/difc-members-club/image1.jpg",
            "/assets/projects/difc-members-club/image2.jpg",
            "/assets/projects/difc-members-club/image3.jpg",
            "/assets/projects/difc-members-club/image4.jpg",
            "/assets/projects/difc-members-club/image5.jpg",
            "/assets/projects/difc-members-club/image6.jpg",
            "/assets/projects/difc-members-club/image7.jpg",
            "/assets/projects/difc-members-club/image8.jpg",
        ],
        detailOne: {
          title: "Ut enim ad minima veniam",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          image: "/assets/projects/difc-members-club/detail1.jpg",
        },

        detailTwo: {
          title: "Quis autem vel eum",
          text: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit",
          image: "/assets/projects/difc-members-club/detail2.jpg",
        },

        inspirationSection: {
          title: "Nam libero tempore",
          description:
            "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio.",
        },

        inspirationBoard: [
          "/assets/projects/difc-members-club/board.jpg",
        ],
      },
      {
        slug: "difc-tower",
        title: "DIFC Tower",
        listImageOuter: "/assets/projects/difc-tower/image1.jpg",
        listImageInner:
          "/assets/projects/difc-tower/image2.jpg",
        hero: "/assets/projects/difc-tower/image2.jpg",

        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        table: {
          headers: [
            "Location",
            "Category",
            "Materials",
            "Area",
            "Architect",
            "Year",
          ],
          details: [
            "Lounge",
            "Interior",
            "Marble, Wood",
            "250 sqm",
            "i/o Atelier",
            "2023",
          ],
        },
        quoteRight:
          "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque",
        quoteCenter:
          "Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam",
        gallery: [
          "/assets/projects/difc-tower/image1.jpg",
          "/assets/projects/difc-tower/image2.jpg",
          "/assets/projects/difc-tower/image3.jpg",
          "/assets/projects/difc-tower/image4.jpg",
          "/assets/projects/difc-tower/image5.jpg",
          "/assets/projects/difc-tower/image6.jpg",
        ],
        detailOne: {
          title: "Ut enim ad minima veniam",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          image: "/assets/projects/difc-tower/image1.jpg",
        },

        detailTwo: {
          title: "Quis autem vel eum",
          text: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit",
          image: "/assets/projects/difc-tower/image1.jpg",
        },

        inspirationSection: {
          title: "Nam libero tempore",
          description:
            "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio.",
        },

        inspirationBoard: [
          "/assets/projects/difc-tower/image1.jpg",
        ],
      },
      {
        slug: "dt1-dubai",
        title: "DT1 Dubai",
        listImageOuter: "/assets/projects/dt1-dubai/DT1_ID_View07.jpg",
        listImageInner: "/assets/projects/dt1-dubai/DT1_ID_View01.jpg",
        hero: "/assets/projects/dt1-dubai/DT1_ID_View01.jpg",

        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        table: {
          headers: [
            "Location",
            "Category",
            "Materials",
            "Area",
            "Architect",
            "Year",
          ],
          details: [
            "Lounge",
            "Interior",
            "Marble, Wood",
            "250 sqm",
            "i/o Atelier",
            "2023",
          ],
        },
        quoteRight:
          "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque",
        quoteCenter:
          "Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam",
        gallery: [
          "/assets/projects/al-khan-sharif/AL%20KHAN_View05.jpg",
          "/assets/projects/al-khan-sharif/AL%20KHAN_View06.jpg",
          "/assets/projects/al-khan-sharif/AL%20KHAN_View07.jpg",
          "/assets/projects/al-khan-sharif/AL%20KHAN_View08.jpg",
          "/assets/projects/al-khan-sharif/AL%20KHAN_View09.jpg",
          "/assets/projects/al-khan-sharif/AL%20KHAN_View10.jpg",
        ],
        detailOne: {
          title: "Ut enim ad minima veniam",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          image: "/assets/projects/al-khan-sharif/AL%20KHAN_View05.jpg",
        },

        detailTwo: {
          title: "Quis autem vel eum",
          text: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit",
          image: "/assets/projects/al-khan-sharif/AL%20KHAN_View07.jpg",
        },

        inspirationSection: {
          title: "Nam libero tempore",
          description:
            "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio.",
        },

        inspirationBoard: [
          "/assets/projects/al-khan-sharif/AL%20KHAN_View05.jpg",
        ],
      },
      {
        slug: "fab",
        title: "FAB",
        listImageOuter: "/assets/projects/fab/image1.jpg",
        listImageInner: "/assets/projects/fab/image2.jpg",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        hero: "/assets/projects/fab/image2.jpg",

        table: {
          headers: [
            "Location",
            "Category",
            "Materials",
            "Area",
            "Architect",
            "Year",
          ],
          details: [
            "Lounge",
            "Interior",
            "Marble, Wood",
            "250 sqm",
            "i/o Atelier",
            "2023",
          ],
        },
        quoteRight:
          "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque",
        quoteCenter:
          "Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam",
        gallery: [
          "/assets/projects/fab/image1.jpg",
          "/assets/projects/fab/image2.jpg",
          "/assets/projects/fab/image3.jpg",
          "/assets/projects/fab/image4.jpg",
          "/assets/projects/fab/image5.jpg",
        ],
        detailOne: {
          title: "Ut enim ad minima veniam",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          image: "/assets/projects/fab/image1.jpg",
        },

        detailTwo: {
          title: "Quis autem vel eum",
          text: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit",
          image: "/assets/projects/fab/image1.jpg",
        },

        inspirationSection: {
          title: "Nam libero tempore",
          description:
            "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio.",
        },

        inspirationBoard: [
          "/assets/projects/fab/image1.jpg",
        ],
      },
      {
        slug: "intercontinental-residence",
        title: "Intercontinental Residence",
        listImageOuter:
          "/assets/projects/intercontinental-residence/image1.jpg",
        listImageInner:
          "/assets/projects/intercontinental-residence/image2.jpg",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        hero: "/assets/projects/intercontinental-residence/image2.jpg",

        table: {
          headers: [
            "Location",
            "Category",
            "Materials",
            "Area",
            "Architect",
            "Year",
          ],
          details: [
            "Lounge",
            "Interior",
            "Marble, Wood",
            "250 sqm",
            "i/o Atelier",
            "2023",
          ],
        },
        quoteRight:
          "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque",
        quoteCenter:
          "Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam",
        gallery: [
          "/assets/projects/intercontinental-residence/image1.jpg",
          "/assets/projects/intercontinental-residence/image2.jpg",
          "/assets/projects/intercontinental-residence/image3.jpg",
          "/assets/projects/intercontinental-residence/image4.jpg",
          "/assets/projects/intercontinental-residence/image5.jpg",
        ],
        detailOne: {
          title: "Ut enim ad minima veniam",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          image: "/assets/projects/intercontinental-residence/image1.jpg",
        },

        detailTwo: {
          title: "Quis autem vel eum",
          text: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit",
          image: "/assets/projects/intercontinental-residence/image1.jpg",
        },

        inspirationSection: {
          title: "Nam libero tempore",
          description:
            "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio.",
        },

        inspirationBoard: [
          "/assets/projects/intercontinental-residence/image1.jpg",
        ],
      },
      {
        slug: "marriott-dq-riyadh",
        title: "Marriott DQ Riyadh",
        listImageOuter:
          "/assets/projects/marriott-dq-riyadh/image2.jpg",
        listImageInner: "/assets/projects/marriott-dq-riyadh/image1.jpg",
        hero: "/assets/projects/marriott-dq-riyadh/image1.jpg",

        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        table: {
          headers: [
            "Location",
            "Category",
            "Materials",
            "Area",
            "Architect",
            "Year",
          ],
          details: [
            "Lounge",
            "Interior",
            "Marble, Wood",
            "250 sqm",
            "i/o Atelier",
            "2023",
          ],
        },
        quoteRight:
          "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque",
        quoteCenter:
          "Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam",
        gallery: [
          "/assets/projects/marriott-dq-riyadh/image1.jpg",
          "/assets/projects/marriott-dq-riyadh/image2.jpg",
          "/assets/projects/marriott-dq-riyadh/image3.jpg",
          "/assets/projects/marriott-dq-riyadh/image4.jpg",
          "/assets/projects/marriott-dq-riyadh/image5.jpg",
          "/assets/projects/marriott-dq-riyadh/image6.jpg",
          "/assets/projects/marriott-dq-riyadh/image7.jpg",
          "/assets/projects/marriott-dq-riyadh/image8.jpg",
          "/assets/projects/marriott-dq-riyadh/image9.jpg",
          "/assets/projects/marriott-dq-riyadh/image10.jpg",
        ],
        detailOne: {
          title: "Ut enim ad minima veniam",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          image: "/assets/projects/marriott-dq-riyadh/image1.jpg",
        },

        detailTwo: {
          title: "Quis autem vel eum",
          text: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit",
          image: "/assets/projects/marriott-dq-riyadh/image1.jpg",
        },

        inspirationSection: {
          title: "Nam libero tempore",
          description:
            "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio.",
        },

        inspirationBoard: [
          "/assets/projects/marriott-dq-riyadh/image1.jpg",
        ],
      },
      {
        slug: "mbr-dubai",
        title: "MBR Dubai",
        listImageOuter: "/assets/projects/mbr-dubai/image1.jpg",
        listImageInner: "/assets/projects/mbr-dubai/image2.jpg",
        hero: "/assets/projects/mbr-dubai/mbr-dubai/image2.jpg",

        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        table: {
          headers: [
            "Location",
            "Category",
            "Materials",
            "Area",
            "Architect",
            "Year",
          ],
          details: [
            "Lounge",
            "Interior",
            "Marble, Wood",
            "250 sqm",
            "i/o Atelier",
            "2023",
          ],
        },
        quoteRight:
          "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque",
        quoteCenter:
          "Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam",
        gallery: [
          "/assets/projects/mbr-dubai/image1.jpg",
          "/assets/projects/mbr-dubai/image2.jpg",
          "/assets/projects/mbr-dubai/image3.jpg",
          "/assets/projects/mbr-dubai/image4.jpg",
          "/assets/projects/mbr-dubai/image5.jpg",
          "/assets/projects/mbr-dubai/image6.jpg",
        ],
        detailOne: {
          title: "Ut enim ad minima veniam",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          image: "/assets/projects/mbr-dubai/image1.jpg",
        },

        detailTwo: {
          title: "Quis autem vel eum",
          text: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit",
          image: "/assets/projects/mbr-dubai/image1.jpg",
        },

        inspirationSection: {
          title: "Nam libero tempore",
          description:
            "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio.",
        },

        inspirationBoard: [
          "/assets/projects/mbr-dubai/image1.jpg",
        ],
      },
      {
        slug: "movenpick-rak",
        title: "Movenpick RAK",
        listImageOuter: "/assets/projects/movenpick-rak/image1.jpg",
        listImageInner: "/assets/projects/movenpick-rak/image2.jpg",
        hero: "/assets/projects/movenpick-rak/image2.jpg",

        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        table: {
          headers: [
            "Location",
            "Category",
            "Materials",
            "Area",
            "Architect",
            "Year",
          ],
          details: [
            "Lounge",
            "Interior",
            "Marble, Wood",
            "250 sqm",
            "i/o Atelier",
            "2023",
          ],
        },
        quoteRight:
          "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque",
        quoteCenter:
          "Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam",
        gallery: [
          "/assets/projects/movenpick-rak/image1.jpg",
          "/assets/projects/movenpick-rak/image2.jpg",
          "/assets/projects/movenpick-rak/image3.jpg",
          "/assets/projects/movenpick-rak/image4.jpg",
          "/assets/projects/movenpick-rak/image5.jpg",
          "/assets/projects/movenpick-rak/image6.jpg",
          "/assets/projects/movenpick-rak/image7.jpg",
          "/assets/projects/movenpick-rak/image8.jpg",
        ],
        detailOne: {
          title: "Ut enim ad minima veniam",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          image: "/assets/projects/assets/projects/movenpick-rak/image1.jpg",
        },

        detailTwo: {
          title: "Quis autem vel eum",
          text: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit",
          image: "/assets/projects/movenpick-rak/image1.jpg",
        },

        inspirationSection: {
          title: "Nam libero tempore",
          description:
            "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio.",
        },

        inspirationBoard: [
          "/assets/projects/movenpick-rak/image1.jpg",
        ],
      },
      {
        slug: "private-residence-athens",
        title: "Private Residence Athens",
        listImageOuter:
          "/assets/projects/private-residence-athens/image1.jpg",
        listImageInner: "/assets/projects/private-residence-athens/image2.jpg",
        hero: "/assets/projects/private-residence-athens/image2.jpg",

        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        table: {
          headers: [
            "Location",
            "Category",
            "Materials",
            "Area",
            "Architect",
            "Year",
          ],
          details: [
            "Lounge",
            "Interior",
            "Marble, Wood",
            "250 sqm",
            "i/o Atelier",
            "2023",
          ],
        },
        quoteRight:
          "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque",
        quoteCenter:
          "Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam",
        gallery: [
          "/assets/projects/private-residence-athens/image1.jpg",
          "/assets/projects/private-residence-athens/image2.jpg",
          "/assets/projects/private-residence-athens/image3.jpg",
          "/assets/projects/private-residence-athens/image4.jpg",
          "/assets/projects/private-residence-athens/image5.jpg",
          "/assets/projects/private-residence-athens/image6.jpg",
          "/assets/projects/private-residence-athens/image7.jpg",
        ],
        detailOne: {
          title: "Ut enim ad minima veniam",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          image: "/assets/projects/private-residence-athens/image1.jpg",
        },

        detailTwo: {
          title: "Quis autem vel eum",
          text: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit",
          image: "/assets/projects/private-residence-athens/image1.jpg",
        },

        inspirationSection: {
          title: "Nam libero tempore",
          description:
            "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio.",
        },

        inspirationBoard: [
          "/assets/projects/private-residence-athens/image1.jpg",
        ],
      },
      {
        slug: "saudi-cinemas",
        title: "Saudi Cinemas",
        listImageOuter: "/assets/projects/saudi-cinemas/image1.jpg",
        listImageInner: "/assets/projects/saudi-cinemas/image2.jpg",
        hero: "/assets/projects/saudi-cinemas/image2.jpg",

        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        table: {
          headers: [
            "Location",
            "Category",
            "Materials",
            "Area",
            "Architect",
            "Year",
          ],
          details: [
            "Lounge",
            "Interior",
            "Marble, Wood",
            "250 sqm",
            "i/o Atelier",
            "2023",
          ],
        },
        quoteRight:
          "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque",
        quoteCenter:
          "Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam",
        gallery: [
          "/assets/projects/saudi-cinemas/image1.jpg",
          "/assets/projects/saudi-cinemas/image2.jpg",
          "/assets/projects/saudi-cinemas/image3.jpg",
          "/assets/projects/saudi-cinemas/image4.jpg",
          "/assets/projects/saudi-cinemas/image5.jpg",
          "/assets/projects/saudi-cinemas/image6.jpg",
          "/assets/projects/saudi-cinemas/image7.jpg",
          "/assets/projects/saudi-cinemas/image8.jpg",
          "/assets/projects/saudi-cinemas/image9.jpg",
        ],
        detailOne: {
          title: "Ut enim ad minima veniam",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          image: "/assets/projects/saudi-cinemas/image1.jpg",
        },

        detailTwo: {
          title: "Quis autem vel eum",
          text: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit",
          image: "/assets/projects/saudi-cinemas/image1.jpg",
        },

        inspirationSection: {
          title: "Nam libero tempore",
          description:
            "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio.",
        },

        inspirationBoard: [
          "/assets/projects/saudi-cinemas/image1.jpg",
        ],
      },
      {
        slug: "shookra-clinic",
        title: "Shookra Clinic",
        listImageOuter:
          "/assets/projects/shookra-clinic/image1.jpg",
        listImageInner:
          "/assets/projects/shookra-clinic/image2.jpg",
        hero: "/assets/projects/shookra-clinic/image2.jpg",

        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        table: {
          headers: [
            "Location",
            "Category",
            "Materials",
            "Area",
            "Architect",
            "Year",
          ],
          details: [
            "Lounge",
            "Interior",
            "Marble, Wood",
            "250 sqm",
            "i/o Atelier",
            "2023",
          ],
        },
        quoteRight:
          "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque",
        quoteCenter:
          "Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam",
        gallery: [
          "/assets/projects/shookra-clinic/image1.jpg",
          "/assets/projects/shookra-clinic/image2.jpg",
          "/assets/projects/shookra-clinic/image3.jpg",
          "/assets/projects/shookra-clinic/image4.jpg",
        ],
        detailOne: {
          title: "Ut enim ad minima veniam",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          image: "/assets/projects/shookra-clinic/image1.jpg",
        },

        detailTwo: {
          title: "Quis autem vel eum",
          text: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit",
          image: "/assets/projects/shookra-clinic/image1.jpg",
        },

        inspirationSection: {
          title: "Nam libero tempore",
          description:
            "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio.",
        },

        inspirationBoard: [
          "/assets/projects/shookra-clinic/image1.jpg",
        ],
      },
      {
        slug: "sky-sports",
        title: "Sky Sports",
        listImageOuter: "/assets/projects/sky-sports/BEIX8760.jpg",
        listImageInner: "/assets/projects/sky-sports/EIYE4849.jpg",
        hero: "/assets/projects/sky-sports/EIYE4849.jpeg",

        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        table: {
          headers: [
            "Location",
            "Category",
            "Materials",
            "Area",
            "Architect",
            "Year",
          ],
          details: [
            "Lounge",
            "Interior",
            "Marble, Wood",
            "250 sqm",
            "i/o Atelier",
            "2023",
          ],
        },
        quoteRight:
          "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque",
        quoteCenter:
          "Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam",
        gallery: [
          "/assets/projects/al-khan-sharif/AL%20KHAN_View05.jpg",
          "/assets/projects/al-khan-sharif/AL%20KHAN_View06.jpg",
          "/assets/projects/al-khan-sharif/AL%20KHAN_View07.jpg",
          "/assets/projects/al-khan-sharif/AL%20KHAN_View08.jpg",
          "/assets/projects/al-khan-sharif/AL%20KHAN_View09.jpg",
          "/assets/projects/al-khan-sharif/AL%20KHAN_View10.jpg",
        ],
        detailOne: {
          title: "Ut enim ad minima veniam",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          image: "/assets/projects/al-khan-sharif/AL%20KHAN_View05.jpg",
        },

        detailTwo: {
          title: "Quis autem vel eum",
          text: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit",
          image: "/assets/projects/al-khan-sharif/AL%20KHAN_View07.jpg",
        },

        inspirationSection: {
          title: "Nam libero tempore",
          description:
            "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio.",
        },

        inspirationBoard: [
          "/assets/projects/al-khan-sharif/AL%20KHAN_View05.jpg",
        ],
      },
      {
        slug: "vida-bahrain",
        title: "VIDA Bahrain",
        listImageOuter: "/assets/projects/vida-bahrain/VIDA_View01.jpg",
        listImageInner: "/assets/projects/vida-bahrain/VIDA_ID_View04.jpg",
        hero: "/assets/projects/vida-bahrain/VIDA_ID_View04.jpg",

        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        table: {
          headers: [
            "Location",
            "Category",
            "Materials",
            "Area",
            "Architect",
            "Year",
          ],
          details: [
            "Lounge",
            "Interior",
            "Marble, Wood",
            "250 sqm",
            "i/o Atelier",
            "2023",
          ],
        },
        quoteRight:
          "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque",
        quoteCenter:
          "Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam",
        gallery: [
          "/assets/projects/al-khan-sharif/AL%20KHAN_View05.jpg",
          "/assets/projects/al-khan-sharif/AL%20KHAN_View06.jpg",
          "/assets/projects/al-khan-sharif/AL%20KHAN_View07.jpg",
          "/assets/projects/al-khan-sharif/AL%20KHAN_View08.jpg",
          "/assets/projects/al-khan-sharif/AL%20KHAN_View09.jpg",
          "/assets/projects/al-khan-sharif/AL%20KHAN_View10.jpg",
        ],
        detailOne: {
          title: "Ut enim ad minima veniam",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          image: "/assets/projects/al-khan-sharif/AL%20KHAN_View05.jpg",
        },

        detailTwo: {
          title: "Quis autem vel eum",
          text: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit",
          image: "/assets/projects/al-khan-sharif/AL%20KHAN_View07.jpg",
        },

        inspirationSection: {
          title: "Nam libero tempore",
          description:
            "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio.",
        },

        inspirationBoard: [
          "/assets/projects/al-khan-sharif/AL%20KHAN_View05.jpg",
        ],
      },
      {
        slug: "warner-brothers-discovery",
        title: "Warner Brothers Discovery",
        listImageOuter:
          "/assets/projects/warner-brothers-discovery/Cam%2003_02.jpg",
        listImageInner:
          "/assets/projects/warner-brothers-discovery/Cam%2003_01.jpg",
        hero: "/assets/projects/warner-brothers-discovery/Cam%2003_01.jpg",

        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        table: {
          headers: [
            "Location",
            "Category",
            "Materials",
            "Area",
            "Architect",
            "Year",
          ],
          details: [
            "Lounge",
            "Interior",
            "Marble, Wood",
            "250 sqm",
            "i/o Atelier",
            "2023",
          ],
        },
        quoteRight:
          "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque",
        quoteCenter:
          "Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam",
        gallery: [
          "/assets/projects/al-khan-sharif/AL%20KHAN_View05.jpg",
          "/assets/projects/al-khan-sharif/AL%20KHAN_View06.jpg",
          "/assets/projects/al-khan-sharif/AL%20KHAN_View07.jpg",
          "/assets/projects/al-khan-sharif/AL%20KHAN_View08.jpg",
          "/assets/projects/al-khan-sharif/AL%20KHAN_View09.jpg",
          "/assets/projects/al-khan-sharif/AL%20KHAN_View10.jpg",
        ],
        detailOne: {
          title: "Ut enim ad minima veniam",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          image: "/assets/projects/al-khan-sharif/AL%20KHAN_View05.jpg",
        },

        detailTwo: {
          title: "Quis autem vel eum",
          text: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit",
          image: "/assets/projects/al-khan-sharif/AL%20KHAN_View07.jpg",
        },

        inspirationSection: {
          title: "Nam libero tempore",
          description:
            "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio.",
        },

        inspirationBoard: [
          "/assets/projects/al-khan-sharif/AL%20KHAN_View05.jpg",
        ],
      },
      {
        slug: "waterfront-hotel-villas-community-abu-dhabi",
        title: "Waterfront Hotel, Villas & Community",
        listImageOuter:
          "/assets/projects/waterfront-hotel-villas-community-abu-dhabi/Emirati%20Bedroom.jpg",
        listImageInner:
          "/assets/projects/waterfront-hotel-villas-community-abu-dhabi/Tropical%20Family%20room.jpg",
        hero: "/assets/projects/waterfront-hotel-villas-community-abu-dhabi/Tropical%20Family%20room.jpg",

        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        table: {
          headers: [
            "Location",
            "Category",
            "Materials",
            "Area",
            "Architect",
            "Year",
          ],
          details: [
            "Lounge",
            "Interior",
            "Marble, Wood",
            "250 sqm",
            "i/o Atelier",
            "2023",
          ],
        },
        quoteRight:
          "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque",
        quoteCenter:
          "Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam",
        gallery: [
          "/assets/projects/al-khan-sharif/AL%20KHAN_View05.jpg",
          "/assets/projects/al-khan-sharif/AL%20KHAN_View06.jpg",
          "/assets/projects/al-khan-sharif/AL%20KHAN_View07.jpg",
          "/assets/projects/al-khan-sharif/AL%20KHAN_View08.jpg",
          "/assets/projects/al-khan-sharif/AL%20KHAN_View09.jpg",
          "/assets/projects/al-khan-sharif/AL%20KHAN_View10.jpg",
        ],
        detailOne: {
          title: "Ut enim ad minima veniam",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          image: "/assets/projects/al-khan-sharif/AL%20KHAN_View05.jpg",
        },

        detailTwo: {
          title: "Quis autem vel eum",
          text: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit",
          image: "/assets/projects/al-khan-sharif/AL%20KHAN_View07.jpg",
        },

        inspirationSection: {
          title: "Nam libero tempore",
          description:
            "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio.",
        },

        inspirationBoard: [
          "/assets/projects/al-khan-sharif/AL%20KHAN_View05.jpg",
        ],
      },
    ],
  }
}

export function getProjectDetails(slug) {
  const { items } = getProjectList() // Get all projects
  const project = items.find(p => p.slug === slug) // Find project by slug

  if (!project) {
    return { is404: true } // Simulate 404 if not found
  }

  return {
    isSuccess: true,
    ...project,
    banner: project.listImageOuter, // Assuming this is the banner image
    content: `<p>Details for ${project.title}</p>`, // Placeholder content
  }
}
